import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import finbeamWordmark from "@/assets/finbeam-wordmark.png";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  const scrollToWaitlist = () => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' }), 100);
    } else {
      document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSection = (sectionId: string) => {
    setOpen(false);
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' }), 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-ink-800/80 backdrop-blur-xl border-b border-white/[0.06]">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="inline-flex items-center leading-none" aria-label="finbeam">
            <img src={finbeamWordmark} alt="finbeam" className="h-8 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('features')} className="text-sm text-white/70 hover:text-white transition-colors">{t("nav.features")}</button>
            <button onClick={() => scrollToSection('preview')} className="text-sm text-white/70 hover:text-white transition-colors">{t("nav.appPreview")}</button>
            <LanguageSwitcher />
            <Button onClick={scrollToWaitlist} className="btn-violet !px-5 !py-2.5 !text-xs">{t("nav.waitlist")}</Button>
          </nav>

          <div className="flex items-center gap-2 md:hidden">
            <LanguageSwitcher />
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button className="p-2 text-white/70 hover:text-white" aria-label={t("nav.menuOpen")}>
                  <Menu className="h-6 w-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[280px] bg-ink-800 border-white/10 text-white">
                <SheetTitle className="sr-only">Navigation</SheetTitle>
                <nav className="flex flex-col space-y-6 mt-8">
                  <button onClick={() => scrollToSection('features')} className="text-lg text-white/80 hover:text-white text-left">{t("nav.features")}</button>
                  <button onClick={() => scrollToSection('preview')} className="text-lg text-white/80 hover:text-white text-left">{t("nav.appPreview")}</button>
                  <Button onClick={scrollToWaitlist} className="btn-violet w-full">{t("nav.waitlist")}</Button>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
